module.exports = __webpack_public_path__ + "static/media/30.0430e67d.mp3";